import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useEnterSubmit } from './common'
import { Button } from '../ui/button'
import { Lock } from 'lucide-react'
import { AuthCard, AuthTextInput } from './auth_card'

interface ResetPasswordFormProps {
    onSubmit: (password: string) => void
    loading: boolean
}

export const ResetPasswordForm = ({ onSubmit, loading }: ResetPasswordFormProps) => {
    const [password, setPassword] = useState('')
    const [passwordConfirmation, setPasswordConfirmation] = useState('')
    const canSubmit = !loading && password === passwordConfirmation

    const submit = () => {
        if (canSubmit && onSubmit) {
            onSubmit(password)
        }
    }

    const onEnter = useEnterSubmit(submit)
    return (
        <AuthCard
            title="Reset password"
            subtitle={
                <Link className="font-medium text-gray-600 hover:text-[#2d72d2]" to="/login">
                    Back to login
                </Link>
            }
        >
            <AuthTextInput
                type="password"
                placeholder="New password"
                disabled={loading}
                value={password}
                onChange={setPassword}
                icon={<Lock />}
            />

            <AuthTextInput
                type="password"
                placeholder="Confirm password"
                disabled={loading}
                value={passwordConfirmation}
                onChange={setPasswordConfirmation}
                onKeyDown={onEnter}
                icon={<Lock />}
            />

            <div>
                <Button
                    loading={loading}
                    intent="primary"
                    type="submit"
                    text="Change password"
                    onClick={submit}
                    disabled={!canSubmit}
                    fill
                    className="h-[37px]"
                />
            </div>
        </AuthCard>
    )
}
